import { useQuery } from "@tanstack/react-query";
import { fetchAccountHealth } from "../api/fetchAccountHealth";

export const useAccountHealth = (companyId, enabled = true) => {
  const { data, error, isLoading, refetch } = useQuery({
    queryKey: ["accountHealth", companyId],
    queryFn: () => fetchAccountHealth(companyId),
    enabled: !!companyId && enabled,
  });

  return {
    data: data?.result || null,
    error,
    isLoading,
    refetch,
  };
};
